var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGnbClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_2491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6994 17.8951L12.2673 10.4817L12.3604 10.3886L19.6385 3.11354C19.8725 2.87215 20.0034 2.54922 20.0034 2.2131C20.0034 1.87698 19.8725 1.55406 19.6385 1.31266C19.3945 1.08132 19.0706 0.953048 18.7343 0.954604C18.3979 0.956159 18.0752 1.08742 17.8333 1.32101L10.4741 8.6915L3.11835 1.3234C2.87407 1.09151 2.54937 0.963313 2.2125 0.965759C1.87562 0.968206 1.55282 1.1011 1.31194 1.33651C1.08084 1.57825 0.953576 1.90079 0.957367 2.23512C0.961158 2.56946 1.09571 2.88903 1.33222 3.12547L8.69269 10.4793L1.32268 17.8545C1.08681 18.0937 0.95459 18.4161 0.95459 18.752C0.95459 19.0879 1.08681 19.4102 1.32268 19.6494C1.56831 19.8775 1.89194 20.003 2.22718 20.0001C2.56241 19.9972 2.88384 19.8662 3.12551 19.6339L10.4848 12.2897L17.85 19.6399C17.9656 19.763 18.1046 19.8619 18.2589 19.9307C18.4131 19.9995 18.5796 20.0369 18.7485 20.0406C18.9153 20.0565 19.0836 20.0335 19.2401 19.9735C19.3966 19.9135 19.537 19.8181 19.6505 19.6948C19.8939 19.4621 20.0356 19.1429 20.045 18.8064C20.0544 18.4699 19.9306 18.1433 19.7006 17.8975",
    fill: "#8A695E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_2491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGnbClose);
export default __webpack_public_path__ + "static/media/icon-gnb-close.2ba69421153eeea763b1844304c6dcca.svg";
export { ForwardRef as ReactComponent };